import * as React from 'react';
import { Box, Typography, Chip, Card, CardActions, CardContent, CardMedia, CardHeader, Link, Stack, CardActionArea } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import Skeleton from '@mui/material/Skeleton';
import breeds from '../../statics/breeds.json'
import default403 from '../../resources/403.png';

const keywords = 'Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom Phantom '

function getBreedByID(breed_id) {
  return breeds.filter(
    function (breeds) { return breeds.nr === parseInt(breed_id) }
  )[0].breed;
}

export function build_breed_gender_str(props){
  //argument: dog object
  var name_gender = props.name
  
  if (props.gender === 'm') {
    name_gender = name_gender + ' ♂';
  } else if (props.gender === 'f') {
    name_gender = name_gender + ' ♀';
  } else {

  }
  return name_gender
  
}

export function build_breed_str(props){
  //argument: dog object
  var breeds_elements = ''
  var breeds_str = ''

  // Build breed string
  if (props.breed_id === "") {
    
    if (props.mixture === true) {
      breeds_elements = 'Mix'
      breeds_str = 'Mix'
    }
  } else {
    var breeds = props.breed_id.split(',')
    breeds = [...breeds].map(c => getBreedByID(c))
    
    // Eine Rasse gefunden

    if (breeds.length === 1) {
      if (props.mixture === true) {
        breeds_elements = <><Link to={'/Rasse/' + breeds[0]} component={RouterLink} title={'Alle ' + breeds[0] + ' finden'} color='inherit' underline='hover'>{breeds[0]}</Link>-Mix</>
        breeds_str = breeds[0] + '-Mix'
      } else {
        breeds_elements = <Link to={'/Rasse/' + breeds[0]} component={RouterLink} title={'Alle ' + breeds[0] + ' finden'} color='inherit' underline='hover'>{breeds[0]}</Link>
        breeds_str = breeds[0]
      }
    } else if (breeds.length === 2) {
      breeds_elements = <><Link to={'/Rasse/' + breeds[0]} component={RouterLink} title={'Alle ' + breeds[0] + ' finden'} color='inherit' underline='hover'>{breeds[0]}</Link>, <Link to={'/Rasse/' + breeds[1]} component={RouterLink} title={'Alle ' + breeds[1] + ' finden'} color='inherit' underline='hover'>{breeds[1]}</Link></>
      breeds_str = breeds[0] + ', ' + breeds[1]
    } else if (breeds.length >= 3) {
      breeds_elements = <><Link to={'/Rasse/' + breeds[0]} component={RouterLink} title={'Alle ' + breeds[0] + ' finden'} color='inherit' underline='hover'>{breeds[0]}</Link>, <Link to={'/Rasse/' + breeds[1]} component={RouterLink} title={'Alle ' + breeds[1] + ' finden'} color='inherit' underline='hover'>{breeds[1]}</Link>, <Link to={'/Rasse/' + breeds[2]} component={RouterLink} title={'Alle ' + breeds[2] + ' finden'} color='inherit' underline='hover'>{breeds[2]}</Link></>
      breeds_str = breeds[0] + ', ' + breeds[1] + ', ' + breeds[2]
    }
  }
  // Nasty fix for /Über Page. TODO: Remove this
  if (breeds && breeds.length === 1 && breeds[0] === 'Mensch') {
    breeds_elements = 'Mensch'
    breeds_str = 'Mensch'
  }
  return [breeds_elements, breeds_str]
}


export function AnimalCard(props) {

  if (props.dog.picture_url == null) {
    props.dog.picture_url = default403
  }
  const images = props.dog.picture_url.split(',')


  const name_gender = build_breed_gender_str(props.dog)

  const [breeds_element, breeds_str] = build_breed_str(props.dog)


  // Build age date
  var age = null

  if (props.dog.birthday != null) {
    age = dateDiffInYears(new Date(props.dog.birthday), new Date())
  }


  function SinglePictureHeader() {
    //This is the including the carousel view. The only picture is displayed as the header image. The heading is at the bottom.
    const description = breeds_str !== '' && breeds_str !== undefined ? breeds_str : 'Mischling'

    return <>
      <CardMedia
        component="img" 
        height="250" 
        //image={images[0] ? images[0] && !images[0].includes('#403') : default403} 
        loading="lazy"
        src={images[0] && !images[0].includes('#403')?images[0]:default403} 
        alt={description + ' ' + props.dog.name + ' wartet im Tierheim auf seine Adoption.'} 
        title={description}
        onError={handleImgError}
        style={{
          objectFit: 'cover',
          objectPosition: 'top',
        }} />

      <CardHeader 
        sx={{padding: '16px 16px 0px 16px', marginBottom: '-10px'}}
        title={name_gender} 
        titleTypographyProps={{ component: 'h2', fontWeight: '500', marginBottom: '-2px'}} 
        subheader={breeds_element !== '' ? breeds_element : 'Platzhalter'} 
        subheaderTypographyProps={{ 
          noWrap: true, 
          color: breeds_element !== '' ? "text.secondary" : "rgba(0, 0, 0, 0);", 
          component: 'h3',
          marginBottom: '5px' }} 
        
          />
        
      
    </>
  }




  images.sort(function (a, b) {
    //sort images by resolution
    const sa = Number(a.split('x')[2])
    const sb = Number(b.split('x')[2])
    return sa - sb;
  });


  return <Card variant='elevation' elevation={8}>
    <CardActionArea component={RouterLink} to={'/Hund/' + props.dog.dog_id} title={'Zur Seite von ' + props.dog.name} rel='nofollow'>

      <SinglePictureHeader />

    </CardActionArea>

    <CardContent sx={{paddingBottom: '0px'}}>
      
    <Typography 
      variant="body1" color={props.dog.description ? "text.primary" : "rgba(0, 0, 0, 0);"} sx={{
          maxWidth: '100%',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 3,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          height: '7.5em' /* Adjust this value to control the height of the text */
        }}>
      {props.dog.description ? props.dog.description : keywords}
      </Typography>







      <Box display="flex" flexDirection="column" >
        <Typography align="right" variant='caption' sx={{ fontSize: 6 }} color="text.primary" gutterBottom={true}>

          <Link href={props.dog.dog_link} target="_blank" rel="noreferrer" title={'zur Seite von ' + props.dog.shelter.name}>
            <Typography variant='caption'>
              {props.dog.dog_link.split('://')[1].split('/')[0]}
            </Typography>
          </Link>

        </Typography>



      </Box>

    </CardContent>



    <CardActions >

      <Stack direction='row' spacing={1}>
        {(() => {
          switch (age) {
            case null:
              return null
            case 0:
              return <Chip label={' Welpe'} />
            case 1:
              return <Chip label={' 1 Jahr'} />
            default:
              return <Chip label={age + ' Jahre'} />

          }
        })()}


        {props.dog.shelter.state === 'Erde' ?
          <Chip label={props.dog.shelter.state} /> :
          <Chip label={props.dog.shelter.state} component={RouterLink} to={'/Bundesland/' + props.dog.shelter.state} clickable={true} title={'Hunde in ' + props.dog.shelter.state + ' finden'} />}
      </Stack>


    </CardActions>
  </Card>;
}



export function SkeletonCard(props) {
  const { contentHeigth = 100 } = props;

  return (
    <Card variant='elevation' elevation={3} >

      <CardContent>
        <Skeleton width="45%" variant='title' animation='wave' sx={{ my: 0.5, p: 0.5 }} />
        <Skeleton width="35%" variant='text' animation='wave' sx={{ my: 0.5 }} />
      </CardContent>


      <CardMedia>
        <Box sx={{ p: 2 }}>
          <Skeleton variant="rectangular" width="100%" height={contentHeigth} animation='wave' />
        </Box>
      </CardMedia>

      <CardContent>

        <Skeleton variant='text' animation='wave' />
        <Skeleton variant='text' animation='wave' />
        <Skeleton variant='text' animation='wave' />
        <Skeleton variant='text' width={'60%'} animation='wave' />
        <Skeleton variant='text' width={'50%'} animation='wave' sx={{ mt: 2, p: 0.35 }} />

      </CardContent>

    </Card>
  )
}

function handleImgError(e) {
  e.target.src = default403;
}

/**function get_width(path, contentHeigth){
  // TODO: Attempt to add site to img label for better SEO (failed)
  return 'auto'
  if (path.includes('#200')){
    // get everything that stands after the last # in path
    var meta = path.split('#')
    meta = meta[meta.length - 1]
    console.log(meta)
    let org_width = meta.split('x')[1]
    let org_heigth = meta.split('x')[2]
    let contentWidth = contentHeigth/org_heigth*org_width
    console.log(contentWidth)
    return contentWidth + 32 //padding left and right
}else{
  return 'auto'
}}*/



function dateDiffInYears(dateold, datenew) {
  var ynew = datenew.getFullYear();
  var mnew = datenew.getMonth();
  var dnew = datenew.getDate();
  var yold = dateold.getFullYear();
  var mold = dateold.getMonth();
  var dold = dateold.getDate();
  var diff = ynew - yold;
  if (mold > mnew) diff--;
  else {
    if (mold === mnew) {
      if (dold > dnew) diff--;
    }
  }
  return diff;
}